export default __webpack_public_path__ + "static/media/imgThree.c06ac999.svg";